import {
    DF_LAT_PRO_V1_3_3,
    DF_LAT_PRO_FILENAME_V1_3_3,
    DF_LAT_LITE_V1_3_4,
    DF_LAT_LITE_FILENAME_V1_3_4,
    DF_LAT_PRO_MANUAL_EN_URL_V1,
    DF_LAT_PRO_MANUAL_EN_FILENAME_V1,
    DF_LAT_LITE_MANUAL_EN_URL_V1,
    DF_LAT_LITE_MANUAL_EN_FILENAME_V1,
} from "../../consts/Installers";

/**
 * リリースノート（DF LAT・英語版）
 * @returns JSX.Element
 */
export const ReleaseNotesDfLatEn = () => {
    return (
        <div>
            {/* Pro版 v2.0.0, Lite版 v2.0.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF LAT Pro v2.0.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF LAT Lite v2.0.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-08-31</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF LAT Pro v2.0.0 has been released.</p>
                    <p>DF LAT Lite v2.0.0 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>New features</p>
                    <p>・TIN-based DTM creation</p>
                    <p>・Screen dock function for each view</p>
                    <p>・Background display</p>
                    <p>・Vector file import</p>
                    <br />
                    <p>Improvements</p>
                    <p>・Improved ground detection and thinning logic</p>
                    <p>・Faster data loading</p>
                    <p>・Faster point cloud editing operations</p>
                    <br />
                    <p>Bug fixes</p>
                    <p>・Fixed an error that occurred when rendering large data</p>
                    <p>
                        ・Fixed an issue where ground detection failed on data with a compound coordinate reference
                        system
                    </p>
                    <p>・Fixed an incorrect distance calculation when the Sectional window was enlarged</p>
                    <p>・Fixed other minor bugs</p>
                    <br />
                    <p className="font-bold">■ Pro Version Only</p>
                    <p>New features</p>
                    <p>・Real-time TIN display</p>
                    <p>・Batch Processing</p>
                    <p>・Data Clip</p>
                    <br />
                    <p>Improvements</p>
                    <p>・Added an option to specify the side length (m) for Data Division</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.3.3, Lite版 v1.3.4 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF LAT Pro v1.3.3</h2>
                <h2 className="my-2 text-2xl font-bold">DF LAT Lite v1.3.4</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-05-12</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF LAT Pro v1.3.3 has been released.</p>
                    <p>DF LAT Lite v1.3.4 has been released.</p>
                    <br />
                    <p>Improved Functions</p>
                    <p>・Improved support for Windows security features.</p>
                    <br />
                </div>
                <hr className="my-2"></hr>
                <p className="mt-2">Download</p>
                <a className="link-text-blue" href={DF_LAT_PRO_V1_3_3}>
                    {DF_LAT_PRO_FILENAME_V1_3_3}
                </a>
                <br />
                <a className="link-text-blue" href={DF_LAT_LITE_V1_3_4}>
                    {DF_LAT_LITE_FILENAME_V1_3_4}
                </a>
                <br />
                <a
                    className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                    href={DF_LAT_PRO_MANUAL_EN_URL_V1}
                    target="_blank"
                    rel="noreferrer noopener"
                >
                    {DF_LAT_PRO_MANUAL_EN_FILENAME_V1}
                </a>
                <br />
                <a
                    className="text-base text-blue-500 hover:text-blue-700 hover:underline"
                    href={DF_LAT_LITE_MANUAL_EN_URL_V1}
                    target="_blank"
                    rel="noreferrer noopener"
                >
                    {DF_LAT_LITE_MANUAL_EN_FILENAME_V1}
                </a>
            </div>

            {/* Lite版 v1.3.3 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF LAT Lite v1.3.3</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-02-25</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF LAT Lite v1.3.3 has been released.</p>
                    <br />
                    <p>New Features</p>
                    <p>・CRS conversion tool enabled in Lite version.</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.3.2, Lite版 v1.3.2 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF LAT Pro v1.3.2</h2>
                <h2 className="my-2 text-2xl font-bold">DF LAT Lite v1.3.2</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-01-29</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF LAT Pro v1.3.2 has been released.</p>
                    <p>DF LAT Lite v1.3.2 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>New Features</p>
                    <p>・Added SHC map creation function.</p>
                    <br />
                    <p>Improvements</p>
                    <p>・Added parameter settings to the CS topographical map creation function.</p>
                    <p>・Speeding up cross section creation.</p>
                    <p>・Supports faster editing operations.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed a bug in the distance calculation function.</p>
                    <p>・Fixed some bugs when importing rasters.</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.3.1, Lite版 v1.3.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF LAT Pro v1.3.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF LAT Lite v1.3.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-12-10</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF LAT Pro v1.3.1 has been released.</p>
                    <p>DF LAT Lite v1.3.1 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>Bug Fixes</p>
                    <p>・Fixed an issue where login failed due to Windows Update .</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.3.0, Lite版 v1.3.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF LAT Pro v1.3.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF LAT Lite v1.3.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-09-01</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF LAT Pro v1.3.0 has been released.</p>
                    <p>DF LAT Lite v1.3.0 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>Improvements</p>
                    <p>
                        ・Improved login-related functions (such as offline deactivation and license expiration
                        notifications).
                    </p>
                    <p>・Improved access to terms of use and related documents from the menu.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>
                        ・Fixed an issue where output of large-size files could fail when creating CHMs or laser forest
                        maps.
                    </p>
                    <p>・Other minor bug fixes.</p>
                    <br />
                    <p className="font-bold">■ Pro Version Only</p>
                    <p>Improvements</p>
                    <p>・Added an option to choose whether to partially overlap regions when splitting point clouds.</p>
                    <p>・Improved DEM merging to properly handle overlapping areas.</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.2.0, Lite版 v1.2.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF LAT Pro v1.2.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF LAT Lite v1.2.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-04-04</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF LAT Pro v1.2.0 has been released.</p>
                    <p>DF LAT Lite v1.2.0 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>New Features</p>
                    <p>・Added a CS topographical map (CS Map) creation feature.</p>
                    <br />
                    <p className="font-bold">■ Pro Version Only</p>
                    <p>Improvements</p>
                    <p>・Accelerated cross-sectional drawing during point cloud editing (manual filtering).</p>
                    <p>
                        ・Added the ability to assign class information to point clouds in ground detection and point
                        cloud editing.
                    </p>
                    <p>・Enabled class-classified point clouds to be displayed by class.</p>
                    <p>・Adjusted the user interface.</p>
                    <p>・Enabled fine-tuning of ground detection parameters.</p>
                    <br />
                    <p className="font-bold">■ Lite Version Only</p>
                    <p>New Features</p>
                    <p>
                        ・Added the point cloud editing (manual filtering) feature, which was previously available only
                        in the Pro version.
                    </p>
                    <p>
                        ・Functions previously included in fully automatic processing—ground detection, rasterization,
                        DSM generation, and CHM calculation—have been added as standalone features, allowing parameter
                        adjustments.
                    </p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.0.1, Lite版 v1.0.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF LAT Pro v1.1.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF LAT Lite v1.1.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-06-05</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF LAT Pro v1.1.0 has been released.</p>
                    <p>DF LAT Lite v1.1.0 has been released.</p>
                    <br />
                    <p className="font-bold">■ For Pro v1.1.0</p>
                    <p>・Added the function to specify slice positions on DEM.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>Bug Fixes</p>
                    <p>
                        ・Fixed an issue where the positions of DSM and DTM were sometimes misaligned during CHM
                        calculation.
                    </p>
                    <p>
                        ・Fixed an issue where shortcuts were not being added to the start menu for non-administrator
                        users.
                    </p>
                    <br />
                    <p>Others</p>
                    <p>・The default installation location for the software has been changed.</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.0.1, Lite版 v1.0.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF LAT Pro v1.0.1</h2>
                <h2 className="my-2 text-2xl font-bold">DF LAT Lite v1.0.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-04-12</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF LAT Pro v1.0.1 has been released.</p>
                    <p>DF LAT Lite v1.0.1 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>New Features</p>
                    <p>・Added laser forest map creation feature.</p>
                    <br />
                    <p>Function Improvements</p>
                    <p>・Optimized ground detection.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed startup issues on some PCs.</p>
                    <br />
                </div>
            </div>

            {/* Pro版 v1.0.0, Lite版 v1.0.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-2xl font-bold">DF LAT Pro v1.0.0</h2>
                <h2 className="my-2 text-2xl font-bold">DF LAT Lite v1.0.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-03-07</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF LAT Pro v1.0.0 has been released.</p>
                    <p>DF LAT Lite v1.0.0 has been released.</p>
                    <br />
                    <p className="font-bold">■ Common</p>
                    <p>Function Improvements</p>
                    <p>・Improved ground detection algorithm.</p>
                    <p>・Part of point cloud drawing has been sped up.</p>
                    <p>・Modified to leave color information when detecting the ground.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Solved the problem of missing data when filtering with special conditions.</p>
                    <p>・Solved the problem where DTM output did not work at a resolution of 50cm.</p>
                    <p></p>
                    <br />
                    <p className="font-bold">■ For Pro v1.0.0</p>
                    <p>・The UI of the "Back" and "Forward" buttons has been partially revised.</p>
                    <br />
                </div>
            </div>

            {/* v1.0.4 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF LAT v1.0.4</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-01-05</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>Update Information</p>
                    <p>・"Back" and "Forward" buttons have been added to manual filtering.</p>
                    <p>・Fixed a bug during login process.</p>
                    <p>・Other minor bugs have been fixed.</p>
                </div>
            </div>

            {/* v1.0.3 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF LAT v1.0.3</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2023-12-13</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>Bug Fixes</p>
                    <p>・Fixed an issue with the functionality of being able to log in for 7 days offline.</p>
                    <br />
                    <p>Feature Improvements</p>
                    <p>・Improved the functionality of the point cloud decimation algorithm.</p>
                </div>
            </div>

            {/* v1.0.2 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF LAT v1.0.2</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2023-12-08</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>Bug Fixes</p>
                    <p>・Restoration of editing information when the software forcibly terminates during editing.</p>
                    <br />
                    <p>Other</p>
                    <p>・Free Trial Version</p>
                    <p>・Manual Updates</p>
                </div>
            </div>

            {/* v1.0.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF LAT v1.0.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2023-10-02</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>Released DF LAT v1.0.0.</p>
                </div>
            </div>
        </div>
    );
};

export default ReleaseNotesDfLatEn;
